import { render } from "./UpdateChangesModal.vue?vue&type=template&id=5066a92b&scoped=true&lang=pug"
import script from "./UpdateChangesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateChangesModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateChangesModal.vue?vue&type=style&index=0&id=5066a92b&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5066a92b"]])

export default __exports__